<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">Adicionar Participante na Arrecadação</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col md="6">
            <v-text-field
              label="Arrecadação"
              :value="fields.fundraising_id.name"
              type="text"
              disabled
              outlined dense
            ></v-text-field>
            <v-autocomplete
              label="Participante"
              v-model="fields.participant_id.value"
              :rules="[...fields.participant_id.rules, ...fields.participant_id.apiErrors]"
              :items="fields.participant_id.options"
              :disabled="($route.query.participant) ? true : false"
              placeholder="Selecione um participante"
              outlined dense
            ></v-autocomplete>
            <decimal-number
              label="Valor total"
              v-model="fields.amount_to_pay.value"
              :rules="[...fields.amount_to_pay.apiErrors]"
              outlined dense
            ></decimal-number>
            <v-autocomplete
              label="Forma de pagamento"
              v-model="fields.method.value"
              :rules="[...fields.method.rules, ...fields.method.apiErrors]"
              :items="methodOptions"
              outlined dense
            ></v-autocomplete>
            <v-autocomplete v-if="!fields.method.value && fields.method.value !== 'monthly'"
              label="Em quais meses?"
              v-model="fields.period.value"
              :rules="[...fields.period.rules, ...fields.period.apiErrors]"
              :items="periodOptions"
              outlined dense
            ></v-autocomplete>
            <v-text-field
              :label="'Quantidade de parcelas (máx: ' + fields.number_of_installment.max + ' parcelas)'"
              v-model="fields.number_of_installment.value"
              :rules="[...fields.number_of_installment.rules, ...fields.number_of_installment.apiErrors]"
              type="number"
              @input="fields.number_of_installment.apiErrors = []"
              outlined dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'userForm',
  components: {
    AppLoading,
    DecimalNumber
  },
  props: ['id', 'celebrationId', 'fundraisingId'],
  data: () => ({
    loading: false,
    fundraisingSettings: {},
    fields: {
      fundraising_id: {
        value: '',
        name: ''
      },
      participant_id: {
        value: '',
        options: [],
        rules: [
          v => !!v || 'O participante é obrigatório'
        ],
        apiErrors: []
      },
      amount_to_pay: {
        value: 0,
        rules: [
          v => !!v || 'O valor total é obrigatório'
        ],
        apiErrors: []
      },
      method: {
        value: '',
        rules: [
          v => !!v || 'A forma de pagamento é obrigatória'
        ],
        apiErrors: []
      },
      period: {
        value: '',
        rules: [
          v => !!v || 'A período é obrigatório'
        ],
        apiErrors: []
      },
      number_of_installment: {
        value: 0,
        max: 0,
        rules: [
          v => !!v || 'O número de parcelas é obrigatório'
        ],
        apiErrors: []
      }
    },
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (key === 'period' && this.fields.method.value === 'monthly') data[key] = 'ALL'
        else if (this.fields[key]) data[key] = this.fields[key].value
      }
      return data
    },
    methodOptions () {
      const options = [
        { value: 'monthly', text: 'Mensal' },
        { value: 'quarterly', text: 'Trimestral' },
        { value: 'semiannual', text: 'Semestral' },
        { value: 'yearly', text: 'Anual' }
      ]
      if (this.fundraisingSettings) {
        const fundraisingOptions = Object.keys(this.fundraisingSettings)
        return options.filter(e => fundraisingOptions.includes(e.value))
      }
      return options
    },
    periodOptions () {
      let settings = {
        monthly: ['ALL'],
        quarterly: ['JAN|ABR|JUL|OUT', 'FEV|MAI|AGO|NOV', 'MAR|JUN|SET|DEZ'],
        semiannual: ['JAN|JUL', 'FEV|AGO', 'MAR|SET', 'ABR|OUT', 'MAI|NOV', 'JUN|DEZ'],
        yearly: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
      }
      if (this.fundraisingSettings && this.fundraisingSettings) {
        settings = this.fundraisingSettings
      }
      if (this.fields.method.value) {
        return settings[this.fields.method.value] || []
      }
      return []
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    send () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        axios('joineds', {
          method: (vue.id) ? 'put' : 'post',
          data: vue.apiData
        })
          .then(response => {
            if (response) {
              vue.sending = false
              vue.SET_SNACKBAR({ text: (vue.id) ? 'Próximos pagamentos atualizados' : 'Participante arrecadando' })
              vue.$router.go(-1)
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  },
  created () {
    let vue = this
    vue.loading = true
    let promises = []

    if (this.fundraisingId) {
      promises.push(new Promise((resolve, reject) => {
        axios.get('fundraisings/' + vue.fundraisingId)
          .then(response => {
            if (response.data) {
              vue.fields.fundraising_id.value = vue.fundraisingId
              vue.fields.fundraising_id.name = response.data.name
              vue.fields.amount_to_pay.value = response.data.unit_price
              vue.fundraisingSettings = response.data.settings
              vue.fields.number_of_installment.value = vue.$moment(response.data.finish_date).date(5).diff(vue.$moment(), 'months') + 1
              vue.fields.method.value = response.data.method
              vue.fields.period.value = response.data.period

              axios.get('participants?page[size]=200&filter[celebration_id]=' + vue.celebrationId)
                .then(responseParticipants => {
                  if (responseParticipants.data) {
                    vue.fields.participant_id.options = responseParticipants.data.data.map(e => {
                      return {
                        value: e.id,
                        text: e.customer.name
                      }
                    }).filter(e => {
                      let index = response.data.participants.filter(i => e.value === i.id)[0]
                      if (!index) return true
                      return false
                    })
                    if (vue.$route.query.participant) vue.fields.participant_id.value = vue.$route.query.participant
                    resolve()
                  } else {
                    reject(responseParticipants)
                  }
                })
                .catch((error) => {
                  reject(error)
                })
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      }))
    }

    if (this.id) {
      promises.push(new Promise((resolve, reject) => {
        axios.get('joineds/' + vue.id)
          .then(response => {
            if (response.data) {
              for (let key in vue.fields) {
                if (response.data[key]) vue.fields[key].value = response.data[key]
              }
              resolve()
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      }))
    }

    Promise.all(promises)
      .then(response => {
        vue.loading = false
      })
      .catch(() => {
        vue.loading = false
        vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
        vue.$router.go(-1)
      })
  }
}
</script>
